import { Component, Element, h, Host, Prop } from "@stencil/core";
import { i18nProvider } from "@trumpf/ux.i18n";
import { ISearchTag, SearchTagType, SearchTagTypeEnum } from "./interface";
import { isEmpty } from "./utils";

const baseClass = "ux-iws-search-tag";

@Component({
    tag: "ux-iws-search-tag",
    styleUrl: "search-tag.scss",
})
export class SearchTag implements ISearchTag {
    @Element() domNode: HTMLUxIwsSearchTagElement;

    /** Type of the tag */
    @Prop({ reflect: true }) type: SearchTagType = SearchTagTypeEnum.Tag;
    /** Label of the tag */
    @Prop() label: string = "";
    /** Name of the related input element */
    @Prop() name: string = "";
    /** Value of the tag */
    @Prop() value: string = "";
    /** Indicates that the related filter is selected */
    @Prop({ reflect: true }) active: boolean;

    render() {
        const { t } = i18nProvider;
        const { active, label, name, type, value } = this;
        const hasActiveValue = active && !isEmpty(value);
        return (
            <Host
                class={{
                    [baseClass]: true,
                    [`${baseClass}--${type}`]: !isEmpty(type),
                }}
            >
                <button class={`${baseClass}__button`} type="button">
                    {type === SearchTagTypeEnum.Group && (
                        <ux-icon name="circle-checkmark" />
                    )}
                    <span class="ux-iws-search-tag__label">
                        <slot>{label}</slot>
                    </span>
                    {type === SearchTagTypeEnum.Group && (
                        <ux-icon name="cross" title={t(`filter.clear`)} />
                    )}
                    {type === SearchTagTypeEnum.Tag && hasActiveValue && (
                        <ux-icon name="cross" title={t(`filter.clear`)} />
                    )}
                    {type === SearchTagTypeEnum.Tag && hasActiveValue && (
                        <input type="hidden" name={name} value={value} />
                    )}
                </button>
            </Host>
        );
    }
}
